import React, { useContext, useEffect, useState } from "react";
import { AppState } from "../App";
import { useWeb3 } from "../contexts/Web3Context";
import Header from "./Navbar";
import Register from "./Register";
import UserInfo from "./UserInfo";
import Socials from "./Socials";
import Navigation from "./Navigation";
import CopyToClipboard from "react-copy-to-clipboard";
import { message } from "antd";
import { TailSpin } from "react-loader-spinner";
import { CopyFilled, LikeFilled } from "@ant-design/icons";
import { ethers } from "ethers";
import { useTimer } from "react-timer-hook";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const baseUrl = process.env.REACT_APP_BASE_URL;

function MyTimer({ expiryTimestamp }) {
  const { seconds, minutes, hours, days } = useTimer({ expiryTimestamp });
  return (
    <div>
      <span>{days} Days, </span>
      <span>{hours.toString().padStart(2, "0")}</span>:
      <span>{minutes.toString().padStart(2, "0")}</span>:
      <span>{seconds.toString().padStart(2, "0")}</span>
    </div>
  );
}

const Dashboard = () => {
  const useAppState = useContext(AppState);
  const {
    staticContract,
    walletAddress,
    isContractReady,
    provider,
    createContract,
    signer,
    contractAddresses,
  } = useWeb3();

  // Initial states
  const [initializing, setInitializing] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const [userId, setUserId] = useState(null);
  // User data states
  const [user, setUser] = useState({
    level: 0,
    income: 0,
    matrixTeam: 0,
    directTeam: 0,
    royaltyIncome: 0,
    referralIncome: 0,
    levelIncome: 0,
  });

  const [selected, setSelected] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
  });

  // Dashboard data states
  const [lvl, setLvl] = useState({ lvl: 0, total: 0 });
  const [packageWid, setPackageWid] = useState(0);
  const [showRoyalty, setShowRoyalty] = useState(false);
  const [roayltyTime, setRoyaltyTime] = useState(0);
  const [royalty, setRoyalty] = useState([0, 0, 0]);
  const [royaltyUsers, setRoyaltyUsers] = useState([[0], [0], [0]]);
  const [totalRoyaltyUsers, setTotalRoyaltyUsers] = useState([0, 0, 0]);
  const [lvlIncome, setLvlIncome] = useState(Array(12).fill(0));
  const [income, setIncome] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const getData = async function (mounted) {
    if (!isContractReady || !staticContract) return;
    try {
      setLoading(true);
      const userId = await staticContract.id(walletAddress);
      //console.log("Loading data for user ID:", userId.toString());
      const userInfo = await staticContract.userInfo(userId);
      if (!mounted) return;
      setUser({
        level: Number(userInfo.level),
        income: useAppState.convert(userInfo.totalIncome),
        matrixTeam: Number(userInfo.totalMatrixTeam),
        directTeam: Number(userInfo.directTeam),
        royaltyIncome: useAppState.convert(userInfo.royaltyIncome),
        referralIncome: useAppState.convert(userInfo.referralIncome),
        levelIncome: useAppState.convert(userInfo.levelIncome),
      });
      setCurrentUserId(userId);
      setPackageWid(parseInt((Number(userInfo.level) * 100) / 12));
      // Get royalty time
      const _royaltyTime = await staticContract.getRoyaltyTime();
      if (!mounted) return;
      setRoyaltyTime(Number(_royaltyTime));
      setShowRoyalty(true);
      // Get royalties
      const [_royalty, _royalty1, _royalty2] = await Promise.all([
        staticContract.royalty(0),
        staticContract.royalty(1),
        staticContract.royalty(2),
      ]);
      if (!mounted) return;
      setRoyalty([
        useAppState.convert(_royalty),
        useAppState.convert(_royalty1),
        useAppState.convert(_royalty2),
      ]);
      // Get level income
      const _lvlIncome = await staticContract.getLevelIncome(userId);
      if (!mounted) return;
      setLvlIncome(_lvlIncome.map(useAppState.convert));
      // Get income history
      const _income = await staticContract.getIncome(userId);
      //console.log("_Income:", _income);
      if (!mounted) return;
      const formattedIncome = _income
        .map((inc) => ({
          from: Number(inc.id),
          time: Number(inc.time) * 1000,
          amount: useAppState.convert(inc.amount),
          layer: Number(inc.layer),
          level: useAppState.levels.indexOf(Number(useAppState.convert(inc.amount))) + 1,//Number(inc.level),
        }))
        .reverse();
      setIncome(formattedIncome);

      //console.log("Current User ID:", currentUserId);
      //console.log("Income:", formattedIncome);

      // Get royalty users
      const [_royaltyUsers, _royaltyUsers1, _royaltyUsers2] = await Promise.all(
        [
          staticContract.getRoyaltyUsers(0),
          staticContract.getRoyaltyUsers(1),
          staticContract.getRoyaltyUsers(2),
        ]
      );
      if (!mounted) return;
      setTotalRoyaltyUsers([
        _royaltyUsers.length,
        _royaltyUsers1.length,
        _royaltyUsers2.length,
      ]);
      setRoyaltyUsers([
        _royaltyUsers.map(Number),
        _royaltyUsers1.map(Number),
        _royaltyUsers2.map(Number),
      ]);
    } catch (error) {
      //console.error("Error loading dashboard data:", error);
      message.error("Failed to load dashboard data");
    } finally {
      if (mounted) {
        setLoading(false);
      }
    }
  };

  // Load dashboard data
  useEffect(() => {
    let mounted = true;

    getData(mounted);
    return () => {
      mounted = false;
    };
  }, [isContractReady, staticContract, walletAddress]);

  useEffect(() => {
    let mounted = true;
    const toastIds = [];
    async function showLevelNotifications() {
      if (user.level > 0 && !useAppState.shown) {
        try {
          // Get recent activities from contract
          const recentActivities = await staticContract.getRecentActivities(5);

          // Clear existing notifications
          //NotificationManager.removeAll();
          // Show notifications with delay
          recentActivities.forEach((activity, index) => {
            setTimeout(() => {
              if (mounted) {
                const toastId = toast.info(
                  `ID: ${Number(activity.id)} just got upgraded to ${
                    useAppState.ranks[Number(activity.level) - 1]
                  }`,
                  {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  }
                );
                toastIds.push(toastId);
                if (index === recentActivities.length - 1) {
                  useAppState.setShown(true);
                }
              }
            }, index * 3300);
          });
        } catch (error) {
          console.error("Error showing level notifications:", error);
        }
      }
    }
    showLevelNotifications();
    return () => {
      mounted = false;
    };
  }, [user.level, useAppState.shown, staticContract]);

  const upgrade = async () => {
    setIsProcessing(true);
    try {
      // Log contract details for debugging
      /*console.log("Contract details:", {
        address: contractAddresses.main, // Use main contract address
        abi: staticContract?.interface,
        signer: signer,
      });*/
      // Create contract instance with explicit parameters
      let contract = await createContract(
        contractAddresses.main, // Use main contract address
        staticContract.interface,
        signer
      );
      // Prepare transaction with proper parameters
      let tx = await contract.upgrade(useAppState.id, lvl.lvl, {
        value: ethers.parseEther(lvl.total.toFixed(5).toString()),
      });
      await tx.wait();
      // Reset level state
      setLvl({
        lvl: 0,
        total: 0,
      });

      message.success("Successfully Upgraded");

      // Refresh data
      getData(true);
    } catch (error) {
      //console.error("Upgrade error:", error);
      message.error(error.reason || "Failed to upgrade");
    } finally {
      setIsProcessing(false);
    }
  };

  const select = (amt, i) => {
    if (selected[i - 1] == true || i == user.level + 1) {
      setLvl((prev) => ({ lvl: prev.lvl + 1, total: prev.total + amt }));
      setSelected((prev) => ({ ...prev, [i]: true }));
    }
  };

  const deSelect = (amt, i) => {
    if (selected[i + 1] == false || i == useAppState.levels.length - 1) {
      setLvl((prev) => ({ lvl: prev.lvl - 1, total: prev.total - amt }));
      setSelected((prev) => ({ ...prev, [i]: false }));
    }
  };

  // Loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="flex flex-col justify-center items-center">
          <TailSpin color="#00BFFF" height={80} width={80} />
          <p className="mt-4 text-gray-600">{"Loading your data..."}</p>
        </div>
      </div>
    );
  }

  if (isProcessing) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="flex flex-col justify-center items-center">
          <TailSpin color="#00BFFF" height={80} width={80} />
          <p className="mt-4 text-gray-600">{"Processing, please wait..."}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <img
        src="bgimg.png"
        className="fixed hidden md:block right-0 top-0 z-0 opacity-100 w-full h-full"
      />
      <img
        src="bgmobimg.png"
        className="fixed w-full left-0 md:top-0 block md:hidden top-0 z-0 opacity-100"
      />

      {/*<NotificationContainer />*/}

      <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative">
        <Header />

        <div className="flex justify-center w-full px-4 mt-6">
          <div className="w-full md:w-3/4">
            <Navigation />
          </div>
        </div>

        <Register />

        <div className="flex justify-center px-4 md:p-0 mt-6">
          <div className="md:w-3/4 w-full">
            {/*<div className="mb-5">
              <Socials />
            </div>*/}
            <div>
              <UserInfo />
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center px-4 md:p-0 mt-6">
          <h1 className="md:w-3/4 w-full flex justify-start overflow-x-auto font-bold text-2xl text-green-500">
            Packages
          </h1>
          <div className="md:w-3/4 w-full flex justify-start gap-x-4 overflow-x-auto">
            {useAppState.levels.map((e, i) => {
              let amt = e + (e * useAppState.percent[i]) / 100;
              return (
                <div
                  key={i}
                  onClick={() => {
                    selected[i] ? deSelect(amt, i) : select(amt, i);
                  }}
                  className={`${i > 0 ? "" : "hidden"} ${
                    user.level >= i ? "hidden" : null
                  } flex-col cursor-pointer blue_blur p-2 mt-4 font-bold text-black dark:text-white min-w-28 min-h-28 flex justify-center items-center rounded-md mb-4 bg-white dark:bg-[#1e2026] shadow-lg`}
                >
                  <p className="text-gray-800 dark:text-[#FFE900] mt-1">
                    {amt.toFixed(5)}
                  </p>
                  <p className="bg-gray-200 rounded-full text-gray-800 min-w-8 flex justify-center items-center text-sm p-1 mt-1">
                    {useAppState.ranks[i - 1]}{" "}
                    {selected[i] ? <span className="ml-1">✅</span> : null}
                  </p>
                  <img src="bnb.png" className="h-8 mt-1" />
                </div>
              );
            })}
          </div>
        </div>

        {Number(lvl.lvl) > 0 ? (
          <div className="flex justify-center px-4 md:p-0 mt-8">
            <div className="md:w-3/4 w-full">
              <button
                onClick={upgrade}
                className="w-full flex justify-center items-center cursor-pointer bg-green-500 rounded-sm text-sm font-bold py-3 px-3 text-white"
              >
                {loading ? (
                  <TailSpin height={15} color="white" />
                ) : (
                  <span>Upgrade {lvl.total.toFixed(5)} BNB</span>
                )}
              </button>
            </div>
          </div>
        ) : null}

        <div className="flex justify-center px-4 md:p-0 mt-6">
          <div className="md:w-3/4 w-full">
            <div className="w-full flex justify-between items-center bg-whtie dark:bg-[#1e2026] dark:bg-opacity-40 rounded-lg shadow-lg p-4">
              <div className="overflow-x-auto overflow-y-hidden">
                <h1 className="text-lg font-bold mb-4 text-white">
                  Referral Link
                </h1>
                <div className="flex justify-between items-center text-2xl">
                  <CopyToClipboard
                    onCopy={() => message.success("Copied!")}
                    text={`${baseUrl}/dashboard?ref=${useAppState.id}`}
                  >
                    <span className="max-w-full cursor-pointer text-sm font-medium overflow-x-auto bg-blue-500 rounded-sm px-3 py-2 text-white whitespace-nowrap">
                      {`${baseUrl}/dashboard?ref=${useAppState.id}`}{" "}
                    </span>
                  </CopyToClipboard>
                  <CopyToClipboard
                    onCopy={() => message.success("Copied!")}
                    text={`${baseUrl}/dashboard?ref=${useAppState.id}`}
                  >
                    <CopyFilled className="ml-2 cursor-pointer text-white" />
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Royalty */}
        <div className="flex justify-center px-4 md:p-0 mt-6">
          <div className="md:w-3/4 w-full">
            <div className="w-full flex flex-col justify-center items-center bg-whtie dark:bg-[#1e2026] dark:bg-opacity-40 rounded-lg shadow-lg p-4">
              <p className="border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] py-3 px-6 font-bold text-xl flex flex-col justify-center">
                <span className="w-full text-center">Daily Royalty</span>
                <span className="w-full text-center">Countdown</span>
              </p>
              {showRoyalty ? (
                <div className="text-2xl mt-2 font-mono px-3 rounded-sm text-white font-bold">
                  {<MyTimer expiryTimestamp={roayltyTime * 1000} />}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="flex justify-center px-4 md:p-0 mt-4">
          <div className="md:w-3/4 w-full">
            <div className="flex justify-start items-center overflow-x-auto w-full">
              <div className="flex justify-center w-full">
                <div
                  className={`overflow-auto max-h-40 flex justify-between items-start w-full px-2 rounded-sm`}
                >
                  <div className="whitespace-nowrap md:ml-0">
                    <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                      <span>
                        L10{" "}
                        <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                          {totalRoyaltyUsers[0]}
                        </span>
                      </span>{" "}
                      <span className="font-bold">
                        {royalty[0]} <span className="text-[#f0c259]">BNB</span>
                      </span>
                    </p>
                    {royaltyUsers[0].map((e, i) => {
                      return (
                        <p
                          key={i}
                          className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                        >
                          {e}
                        </p>
                      );
                    })}
                  </div>

                  <div className="whitespace-nowrap ml-4 md:ml-0">
                    <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                      <span>
                        L11{" "}
                        <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                          {totalRoyaltyUsers[1]}
                        </span>
                      </span>{" "}
                      <span className="font-bold">
                        {royalty[1]} <span className="text-[#f0c259]">BNB</span>
                      </span>
                    </p>
                    {royaltyUsers[1].map((e, i) => {
                      return (
                        <p
                          key={i}
                          className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                        >
                          {e}
                        </p>
                      );
                    })}
                  </div>

                  <div className="whitespace-nowrap ml-4 md:ml-0">
                    <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                      <span>
                        L12{" "}
                        <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                          {totalRoyaltyUsers[2]}
                        </span>
                      </span>{" "}
                      <span className="font-bold">
                        {royalty[2]} <span className="text-[#f0c259]">BNB</span>
                      </span>
                    </p>
                    {royaltyUsers[2].map((e, i) => {
                      return (
                        <p
                          key={i}
                          className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                        >
                          {e}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center px-4 md:p-0 mt-8">
          <div className="md:w-3/4 w-full">
            <div className="flex flex-col md:flex-row justify-between text-white">
              <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    Total Income
                  </p>
                  <p className="text-xl font-bold">{user.income} BNB</p>
                </div>
                <img src="bnb.png" className="h-12" />
              </div>
              <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    Referral Income
                  </p>
                  <p className="text-xl font-bold">{user.referralIncome} BNB</p>
                </div>
                <img src="bnb.png" className="h-12" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center px-4 md:p-0 mt-4">
          <div className="md:w-3/4 w-full">
            <div className="flex flex-col md:flex-row justify-between text-white">
              <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    Level Income
                  </p>
                  <p className="text-xl font-bold">{user.levelIncome} BNB</p>
                </div>
                <img src="bnb.png" className="h-12" />
              </div>
              <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    Royalty Income
                  </p>
                  <p className="text-xl font-bold">{user.royaltyIncome} BNB</p>
                </div>
                <img src="bnb.png" className="h-12" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center px-4 md:p-0 mt-4">
          <div className="md:w-3/4 w-full">
            <div className="flex flex-col md:flex-row justify-between text-white">
              <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    My Community Size
                  </p>
                  <p className="text-xl font-bold">{user.matrixTeam}</p>
                </div>
                <img src="matrix.png" className="h-12" />
              </div>
              <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                <div>
                  <p className="text-lg font-bold text-[#FFE900]">
                    Direct Referrals
                  </p>
                  <p className="text-xl font-bold">{user.directTeam}</p>
                </div>
                <img src="leader.png" className="h-12" />
              </div>
            </div>
          </div>
        </div>

        {/* Lvl Income */}
        <div className="flex justify-center px-4 md:p-0 mt-8">
          <div className="md:w-3/4 w-full">
            <h1 className="font-bold text-2xl px-2">
              Rank <span className="text-green-500">Income</span>
            </h1>
            <div className="overflow-auto flex justify-between w-full mt-2 p-2 rounded-sm">
              <div className="whitespace-nowrap ml-0 md:ml-0 w-1/2">
                <p className="text-center text-lime-500 whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                  Rank
                </p>
                {useAppState.ranks.map((e, i) => {
                  return (
                    <p
                      key={i}
                      className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                    >
                      {e}
                    </p>
                  );
                })}
              </div>

              <div className="whitespace-nowrap ml-4 w-1/2">
                <p className="text-center text-lime-500 whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                  Amount
                </p>
                {lvlIncome.map((e, i) => {
                  return (
                    <p
                      key={i}
                      className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                    >
                      {e} <span className="text-[#FFE900]">BNB</span>
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {income.length > 0 ? (
          <div className="flex justify-center px-4 md:p-0 mt-8">
            <div className="md:w-3/4 w-full">
              <h1 className="font-bold text-2xl px-2">
                Recent <span className="text-green-500">Income</span>
              </h1>
              <div className="overflow-auto h-52 flex justify-between w-full mt-2 p-2 rounded-sm">
                <div className="whitespace-nowrap ml-0 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    From
                  </p>
                  {income.map((e, i) => {
                    return (
                      <p
                        key={i}
                        className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                      >
                        {e.from}
                      </p>
                    );
                  })}
                </div>

                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Amount
                  </p>
                  {income.map((e, i) => {
                    return (
                      <p
                        key={i}
                        className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                      >
                        {e.amount} <span className="text-[#f0c259]">BNB</span>
                      </p>
                    );
                  })}
                </div>

                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Rank Level
                  </p>
                  {income.map((e, i) => {
                    return (
                      <p
                        key={i}
                        className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                      >
                        {e.level == 0
                          ? "Royalty"
                          : `${useAppState.ranks[e.level - 2]}`}
                      </p>
                    );
                  })}
                </div>

                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Layer
                  </p>
                  {income.map((e, i) => {
                    return (
                      <p
                        key={i}
                        className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                      >
                        {e.layer == 0 ? "Royalty" : `Layer ${e.layer}`}
                      </p>
                    );
                  })}
                </div>

                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Time
                  </p>
                  {income.map((e, i) => {
                    return (
                      <p
                        key={i}
                        className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                      >
                        {useAppState.getUTCTime(e.time)}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <div className="flex justify-center px-4 md:p-0 mt-10 mb-4">
          <div className="md:w-3/4 w-full">
            <div className="w-full flex flex-col justify-center items-center">
              <h4 className="font-bold">MoBnb Contract opbnb.bscscan</h4>
              <a
                className="text-yellow-400 underline"
                href={`${process.env.REACT_APP_CHAIN_EXPLORER}/address/${process.env.REACT_APP_MAIN_CONTRACT}`}
                target="_blank"
              >
                {process.env.REACT_APP_MAIN_CONTRACT}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
